import { render } from "./kgo-card.vue?vue&type=template&id=dce7deae&scoped=true"
import script from "./kgo-card.vue?vue&type=script&lang=js"
export * from "./kgo-card.vue?vue&type=script&lang=js"

import "./kgo-card.vue?vue&type=style&index=0&id=dce7deae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dce7deae"]])

export default __exports__